"use strict";
// ToDo: Rename it to generic VoiceCommandIds
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictationEventsType = exports.SpeechSessionEventIds = exports.WordVoiceCommandValueKeys = exports.internalCommandIds = exports.WordVoiceCommandIds = void 0;
var WordVoiceCommandIds;
(function (WordVoiceCommandIds) {
    WordVoiceCommandIds["Bold"] = "Word.Editing.Bold";
    WordVoiceCommandIds["CenterJustify"] = "Word.Editing.CenterJustify";
    WordVoiceCommandIds["CreateBulletList"] = "Word.Editing.CreateBulletList";
    WordVoiceCommandIds["CreateNumberedList"] = "Word.Editing.CreateNumberedList";
    WordVoiceCommandIds["Delete"] = "Word.Editing.Delete";
    WordVoiceCommandIds["Deselect"] = "Word.Editing.Deselect";
    WordVoiceCommandIds["Exit"] = "Command.Exit";
    WordVoiceCommandIds["ExitList"] = "Word.Editing.ExitList";
    WordVoiceCommandIds["FullJustify"] = "Word.Editing.FullJustify";
    WordVoiceCommandIds["Highlight"] = "Word.Editing.Highlight";
    WordVoiceCommandIds["SetFont"] = "Word.Editing.SetFont";
    WordVoiceCommandIds["InsertText"] = "Word.Editing.InsertText";
    WordVoiceCommandIds["InsertBullet"] = "Word.Editing.InsertBullet";
    WordVoiceCommandIds["InsertComment"] = "Word.Editing.InsertComment";
    WordVoiceCommandIds["InsertEmoji"] = "Word.Editing.InsertEmoji";
    WordVoiceCommandIds["InsertTable"] = "Word.Editing.Table.Insert";
    WordVoiceCommandIds["DeleteTable"] = "Word.Editing.Table.Delete";
    WordVoiceCommandIds["NavigateTable"] = "Word.Editing.Table.Navigate";
    WordVoiceCommandIds["Navigation"] = "Word.Editing.Navigation";
    WordVoiceCommandIds["InsertSpace"] = "Word.Editing.InsertSpace";
    WordVoiceCommandIds["Italics"] = "Word.Editing.Italics";
    WordVoiceCommandIds["LeftJustify"] = "Word.Editing.LeftJustify";
    WordVoiceCommandIds["NewLine"] = "Word.Editing.NewLine";
    WordVoiceCommandIds["NextBullet"] = "Word.Editing.NextBullet";
    WordVoiceCommandIds["NextLine"] = "Word.Editing.NextLine";
    WordVoiceCommandIds["Pause"] = "Command.Pause";
    WordVoiceCommandIds["Paste"] = "Word.Editing.Paste";
    WordVoiceCommandIds["ReadBack"] = "Word.Editing.ReadBack";
    WordVoiceCommandIds["Redo"] = "Word.Editing.Redo";
    WordVoiceCommandIds["RightJustify"] = "Word.Editing.RightJustify";
    WordVoiceCommandIds["RemoveBold"] = "Word.Editing.RemoveBold";
    WordVoiceCommandIds["RemoveItalics"] = "Word.Editing.RemoveItalics";
    WordVoiceCommandIds["RemoveUnderline"] = "Word.Editing.RemoveUnderline";
    WordVoiceCommandIds["RemoveHighlight"] = "Word.Editing.RemoveHighlight";
    WordVoiceCommandIds["RemoveSuperscript"] = "Word.Editing.RemoveSuperscript";
    WordVoiceCommandIds["RemoveStrikeThrough"] = "Word.Editing.RemoveStrikeThrough";
    WordVoiceCommandIds["RemoveSubscript"] = "Word.Editing.RemoveSubscript";
    WordVoiceCommandIds["RemoveFormatting"] = "Word.Editing.RemoveFormatting";
    WordVoiceCommandIds["Quote"] = "Word.Editing.Quote";
    WordVoiceCommandIds["Select"] = "Word.Editing.Select";
    WordVoiceCommandIds["Superscript"] = "Word.Editing.Superscript";
    WordVoiceCommandIds["Subscript"] = "Word.Editing.Subscript";
    WordVoiceCommandIds["StrikeThrough"] = "Word.Editing.StrikeThrough";
    WordVoiceCommandIds["ShowHelp"] = "Command.ShowHelp";
    WordVoiceCommandIds["ShowCommands"] = "Command.ShowCommand";
    WordVoiceCommandIds["Undo"] = "Word.Editing.Undo";
    WordVoiceCommandIds["Underline"] = "Word.Editing.Underline";
    WordVoiceCommandIds["IncreaseIndent"] = "Word.Editing.IncreaseIndent";
    WordVoiceCommandIds["DecreaseIndent"] = "Word.Editing.DecreaseIndent";
    WordVoiceCommandIds["Backspace"] = "Word.Editing.Backspace";
    WordVoiceCommandIds["VoiceCommand"] = "Command.VoiceCommand";
    WordVoiceCommandIds["Type"] = "Command.Type";
    WordVoiceCommandIds["ShrinkFont"] = "Word.Editing.ShrinkFont";
    WordVoiceCommandIds["GrowFont"] = "Word.Editing.GrowFont";
    WordVoiceCommandIds["AllCaps"] = "Word.Editing.AllCaps";
    WordVoiceCommandIds["SentenceCase"] = "Word.Editing.SentenceCase";
    WordVoiceCommandIds["LowerCase"] = "Word.Editing.LowerCase";
    WordVoiceCommandIds["Tab"] = "Word.Editing.Tab";
    WordVoiceCommandIds["ZoomOut"] = "Word.View.ZoomOut";
    WordVoiceCommandIds["ZoomIn"] = "Word.View.ZoomIn";
    WordVoiceCommandIds["ScrollUp"] = "Word.View.ScrollUp";
    WordVoiceCommandIds["ScrollDown"] = "Word.View.ScrollDown";
    WordVoiceCommandIds["ShowOutline"] = "Word.View.ShowOutline";
    WordVoiceCommandIds["PageBreak"] = "Word.Editing.PageBreak";
    WordVoiceCommandIds["ResumeDictation"] = "Word.Editing.ResumeDictation";
    WordVoiceCommandIds["Correction"] = "Word.Editing.Correction";
    WordVoiceCommandIds["Style"] = "Word.Editing.Style";
    // Outlook
    WordVoiceCommandIds["Send"] = "Outlook.Send";
    WordVoiceCommandIds["Cancel"] = "Outlook.Cancel";
    WordVoiceCommandIds["Yes"] = "Outlook.Yes";
    WordVoiceCommandIds["AddRecipient"] = "Outlook.AddRecipient";
    WordVoiceCommandIds["AtMention"] = "Outlook.AtMention";
    WordVoiceCommandIds["FieldEdit"] = "Outlook.FieldEdit";
    // Moonshot voice commands below here
    WordVoiceCommandIds["MoonshotAbout"] = "Annotation.Document.About";
    WordVoiceCommandIds["MoonshotReadFromBeginning"] = "Annotation.Document.FromBeginning";
    WordVoiceCommandIds["MoonshotKeyPoints"] = "Annotation.Document.KeyPoints";
    WordVoiceCommandIds["MoonshotOutline"] = "Annotation.Document.Outline";
    WordVoiceCommandIds["MoonshotReadInFull"] = "Annotation.Document.ReadInFull";
    WordVoiceCommandIds["MoonshotSummarize"] = "Annotation.Document.Summary";
    WordVoiceCommandIds["MoonshotMicrophoneOff"] = "Audio.MicrophoneOff";
    WordVoiceCommandIds["MoonshotPause"] = "Audio.Pause";
    WordVoiceCommandIds["MoonshotPlay"] = "Audio.Play";
    WordVoiceCommandIds["MoonshotReplay"] = "Audio.Replay";
    WordVoiceCommandIds["MoonshotSlowDown"] = "Audio.SlowDown";
    WordVoiceCommandIds["MoonshotSpeedUp"] = "Audio.SpeedUp";
    WordVoiceCommandIds["MoonshotReadSection"] = "Document.Action.ReadSection";
    WordVoiceCommandIds["MoonshotRepeat"] = "Document.Action.Repeat";
    WordVoiceCommandIds["MoonshotReview"] = "Document.Action.Review";
    WordVoiceCommandIds["MoonshotDocumentAge"] = "Document.Metadata.Age";
    WordVoiceCommandIds["MoonshotDocumentAuthor"] = "Document.Metadata.Author";
    WordVoiceCommandIds["MoonshotDocumentHits"] = "Document.Metadata.Hits";
    WordVoiceCommandIds["MoonshotDocumentLength"] = "Document.Metadata.Length";
    WordVoiceCommandIds["MoonshotDocumentPreview"] = "Document.Metadata.Preview";
    WordVoiceCommandIds["MoonshotDocumentTitle"] = "Document.Metadata.Title";
    WordVoiceCommandIds["MoonshotNo"] = "General.No";
    WordVoiceCommandIds["MoonshotYes"] = "General.Yes";
    WordVoiceCommandIds["MoonshotIntro"] = "intro";
    WordVoiceCommandIds["MoonshotNextDocument"] = "Navigate.Document.Next";
    WordVoiceCommandIds["MoonshotPreviousDocument"] = "Navigate.Document.Previous";
    // Excel voice commands below here
    // Task 4335772: This code works only on dev and test environments. Remove it soon after hackathon is done
    WordVoiceCommandIds["ExcelIntent"] = "ExcelIntent";
    // Internal voice command IDs, these will be generated as VoiceCommandInternalResult annotations, which are
    // not meant to be consumed by the client but other workflows.
    WordVoiceCommandIds["InternalReadBack"] = "Internal.Word.Editing.ReadBack";
    /** A special case commandId that means no response or annotations should be emitted, not even plain Dictation. */
    WordVoiceCommandIds["NoOp"] = "NoOp";
})(WordVoiceCommandIds = exports.WordVoiceCommandIds || (exports.WordVoiceCommandIds = {}));
// Internal command IDs
exports.internalCommandIds = new Set([WordVoiceCommandIds.InternalReadBack]);
var WordVoiceCommandValueKeys;
(function (WordVoiceCommandValueKeys) {
    WordVoiceCommandValueKeys["TableColumns"] = "Word.Editing.InsertTable.TableColumns";
    WordVoiceCommandValueKeys["TableRows"] = "Word.Editing.InsertTable.TableRows";
    WordVoiceCommandValueKeys["SelectionType"] = "Word.Editing.ActOnSelection.SelectionType";
})(WordVoiceCommandValueKeys = exports.WordVoiceCommandValueKeys || (exports.WordVoiceCommandValueKeys = {}));
var SpeechSessionEventIds;
(function (SpeechSessionEventIds) {
    SpeechSessionEventIds["SpeechRecognitionStarted"] = "SpeechRecognitionStarted";
    SpeechSessionEventIds["SpeechRecognitionStopped"] = "SpeechRecognitionStopped";
    /** Triggered once we get a session ID for ASR. */
    SpeechSessionEventIds["SpeechSessionStarted"] = "SpeechSessionStarted";
    SpeechSessionEventIds["SpeechSessionStopped"] = "SpeechSessionStopped";
})(SpeechSessionEventIds = exports.SpeechSessionEventIds || (exports.SpeechSessionEventIds = {}));
var DictationEventsType;
(function (DictationEventsType) {
    DictationEventsType["MicrophoneError"] = "ErrorAudioCaptureAsync";
})(DictationEventsType = exports.DictationEventsType || (exports.DictationEventsType = {}));
//# sourceMappingURL=voice-definitions.js.map